import { CircleHelp } from 'lucide-react';
import { Tooltip } from './tooltip.js';

/// Ícone (?) ao lado de um rótulo que explica o campo ao pousar o ponteiro ou focar pelo teclado.
/// O nome acessível diz do que se trata; o texto da explicação vem pela dica.
export function HelpTip({ label, content }: { label: string; content: string }) {
  return (
    <Tooltip content={content}>
      <button
        type="button"
        aria-label={label}
        aria-description={content}
        className="inline-grid size-5 cursor-help place-items-center rounded-full text-content-faint transition hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50"
      >
        <CircleHelp className="size-3.5" aria-hidden="true" />
      </button>
    </Tooltip>
  );
}
